module.exports = __webpack_public_path__ + "img/image2.39f0aeb2.jpg";